import { render, staticRenderFns } from "./PostponementView.vue?vue&type=template&id=73d2d98e&"
import script from "./PostponementView.vue?vue&type=script&lang=ts&"
export * from "./PostponementView.vue?vue&type=script&lang=ts&"
import style0 from "./PostponementView.vue?vue&type=style&index=0&id=73d2d98e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports